import React from 'react';
import {
    FormControlLabel,
    Grid,
    Typography,
    Checkbox as Check,
} from '@mui/material';
import FieldSelect from './fieldSelect'; // Asegúrate de tener la ruta correcta
// import { SwitchBaseProps } from '@mui/material/internal/SwitchBase';
import { FocusEventHandler } from 'react';

interface Props {
    id?: string;
    name?: string;
    label?: string;
    checked?: boolean;
    onChange?: (value: boolean) => void;
    onBlur?: FocusEventHandler | undefined;
    beforeLabel?: string;
    disabled?: boolean;
    errors?: string;
    isCheckMode?: boolean;
    data?: { id: string; name: string }[];
    value?: string | undefined;
}

export const Checkbox = ({
    beforeLabel,
    label,
    id,
    name,
    checked = false,
    onChange,
    onBlur,
    disabled,
    errors,
    isCheckMode = false,
    data = [],
    value,
}: Props) => {
    const derivedData =
        data.length === 0
            ? [
                { id: 'true', name: 'Sí' },
                { id: 'false', name: 'No' },
            ]
            : data;

    const derivedValue = isCheckMode
        ? undefined
        : value || (checked ? 'true' : 'false');

    const handleCheckboxChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        if (onChange) {
            onChange(event.target.checked);
        }
    };

    const handleSelectChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        if (onChange) {
            const newValue = event.target.value === 'true';
            onChange(newValue);
        }
    };

    return (
        <Grid position="relative">
            {isCheckMode && beforeLabel && (
                <Typography
                    style={{
                        color: '#2B212B',
                        fontSize: '12px',
                        fontWeight: 'bold',
                        position: 'absolute',
                        top: -10,
                    }}
                >
                    {beforeLabel}
                </Typography>
            )}

            {isCheckMode ? (
                <FormControlLabel
                    control={
                        <Check
                            id={id}
                            name={name}
                            checked={Boolean(checked)}
                            onChange={handleCheckboxChange}
                            onBlur={onBlur}
                            disabled={disabled}
                        />
                    }
                    label={label}
                />
            ) : (
                <FieldSelect
                    data={derivedData}
                    label={label || ''}
                    name={name || ''}
                    value={derivedValue}
                    onChange={handleSelectChange}
                    onBlur={onBlur}
                    disabled={disabled}
                />
            )}

            {errors && (
                <Typography
                    style={{
                        color: '#d32f2f',
                        fontSize: '0.75rem',
                    }}
                    mx="14px"
                >
                    {errors}
                </Typography>
            )}
        </Grid>
    );
};
